import { useAppSelector } from '../store/hooks';

export const useFeatureAccess = () => {
  const feature_access = useAppSelector(state => state.results.feature_access);

  return {
    hasConfidenceBadgesAccess: feature_access?.confidence_badges ?? false,
    hasVerificationAccess: feature_access?.email_verification ?? false,
    hasDMUnlockAccess: feature_access?.dm_unlock ?? false,
    hasReviewsAccess: feature_access?.reviews ?? false,
  };
};
